import React, { useState } from "react";
import feemonk_logo from "../../Assets/images/feemonk_logo.png";
import { useDispatch } from "react-redux";
import { userActions } from "../../actions/user.actions";
const BUSINESS_CATEGORIES = [
  "K-12",
  "Higher Education",
  "Upskilling",
  "Executive Education",
];
const BUSINESS_TYPES = [
  "Private Limited",
  "Limited Liability",
  "Partnership Firm",
  "Proprietorship",
  "Trust/Society",
  "Other",
];
const VINTAGES = ["0-1 Year", "2-3 Years", ">3 Years"];
const TURNOVERS = ["0-50L", "51-1Cr", "1-2Cr", "2-3Cr", "3-5Cr", ">5Cr"];

const initialFormState = {
  businessName: "",
  legalEntityName: "",
  website: "",
  businessType: "",
  businessCategory: "",
  vintage: "",
  turnover: "",
  hasGST: "",
  mobile: "",
  email: "",
};

const urlPattern = /^https?:\/\/([\w-]+\.)+[\w-]+(\/[\w\-./?%&=]*)?$/i;

// Feemonk brand styles
const styles = {
  wrapper: {
    minHeight: "100vh",
    background: "#f8f9fa",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "30px 16px",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 2px 20px rgba(0,0,0,0.06)",
    width: "100%",
    maxWidth: "620px",
    padding: "16px 32px 28px",
    boxSizing: "border-box",
    textAlign: "left",
    overflow: "hidden",
  },
  headerTag: {
    display: "inline-block",
    background: "#FFF3E6",
    color: "#F57C20",
    fontSize: "0.7rem",
    fontWeight: 600,
    padding: "4px 12px",
    borderRadius: "20px",
    marginBottom: "12px",
    letterSpacing: "0.3px",
  },
  title: {
    fontSize: "1.35rem",
    fontWeight: 700,
    color: "#1a1a2e",
    margin: "0 0 6px",
    lineHeight: 1.3,
  },
  subtitle: {
    fontSize: "0.8rem",
    color: "#6b7280",
    margin: "0 0 24px",
    lineHeight: 1.5,
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "0 16px",
  },
  fieldGroup: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "16px",
  },
  label: {
    display: "flex",
    textAlign: "left",
    fontSize: "0.75rem",
    fontWeight: 600,
    color: "#374151",
    padding: 0,
    margin: "0 0 4px 0",
    whiteSpace: "nowrap",
  },
  required: {
    color: "#F57C20",
    marginLeft: "2px",
  },
  input: {
    width: "100%",
    height: "40px",
    padding: "0 12px",
    fontSize: "0.8rem",
    color: "#1a1a2e",
    background: "#f9fafb",
    border: "1.5px solid #e5e7eb",
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.25s ease",
    boxSizing: "border-box",
    textAlign: "left",
    display: "block",
  },
  select: {
    width: "100%",
    height: "40px",
    padding: "0 12px",
    paddingRight: "32px",
    fontSize: "0.8rem",
    color: "#000000",
    background: "#f9fafb",
    border: "1.5px solid #e5e7eb",
    borderRadius: "8px",
    outline: "none",
    transition: "all 0.25s ease",
    boxSizing: "border-box",
    textAlign: "left",
    display: "block",
    cursor: "pointer",
    appearance: "none",
    backgroundImage:
      "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23F57C20' d='M6 8.825a.5.5 0 01-.354-.146l-4-4a.5.5 0 01.708-.708L6 7.617l3.646-3.646a.5.5 0 01.708.708l-4 4A.5.5 0 016 8.825z'/%3E%3C/svg%3E\")",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 12px center",
  },
  selectFocused: {
    borderColor: "#F57C20",
    boxShadow: "0 0 0 3px rgba(245, 124, 32, 0.12)",
    background: "#fff",
  },
  selectPlaceholder: {
    color: "#6b7280",
  },
  selectHasValue: {
    color: "#000000",
    fontWeight: 500,
  },
  toggleWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "6px",
  },
  toggleTrack: {
    width: "44px",
    height: "24px",
    borderRadius: "12px",
    cursor: "pointer",
    position: "relative",
    transition: "background 0.25s ease",
    flexShrink: 0,
  },
  toggleThumb: {
    position: "absolute",
    top: "3px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "#fff",
    boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
    transition: "left 0.25s ease",
  },
  toggleLabel: {
    fontSize: "0.8rem",
    fontWeight: 600,
    transition: "color 0.2s",
  },
  submitBtn: {
    display: "block",
    width: "calc(100% - 64px)",
    height: "42px",
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#fff",
    background: "#F57C20",
    border: "none",
    borderRadius: "50px",
    cursor: "pointer",
    marginTop: "4px",
    textAlign: "center",
    lineHeight: "42px",
    padding: "0 28px",
    boxSizing: "border-box",
  },
  submitBtnDisabled: {
    display: "block",
    width: "calc(100% - 64px)",
    height: "42px",
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "#fff",
    background: "#F57C20",
    border: "none",
    borderRadius: "50px",
    cursor: "not-allowed",
    opacity: 0.6,
    marginTop: "4px",
    textAlign: "center",
    lineHeight: "42px",
    padding: "0 28px",
    boxSizing: "border-box",
  },
  error: {
    color: "#ef4444",
    fontSize: "0.7rem",
    display: "block",
    marginTop: "3px",
    textAlign: "left",
  },
  successIcon: {
    width: "56px",
    height: "56px",
    margin: "0 auto 16px",
    background: "#F57C20",
    color: "#fff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.5rem",
    fontWeight: 700,
  },
};

export default function OnboardingForm() {
  const dispatch = useDispatch();
  const [form, setForm] = useState(initialFormState);
  const [status, setStatus] = useState("idle");
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const onInputFocus = (e) => {
    e.target.style.borderColor = "#F57C20";
    e.target.style.boxShadow = "0 0 0 3px rgba(245, 124, 32, 0.12)";
    e.target.style.background = "#fff";
  };
  const onInputBlur = (e) => {
    e.target.style.borderColor = "#e5e7eb";
    e.target.style.boxShadow = "none";
    e.target.style.background = "#f9fafb";
  };
  const onSelectHover = (e) => {
    if (document.activeElement !== e.target) {
      e.target.style.borderColor = "#F5A623";
      e.target.style.background = "#fffaf5";
    }
  };
  const onSelectLeave = (e) => {
    if (document.activeElement !== e.target) {
      e.target.style.borderColor = "#e5e7eb";
      e.target.style.background = "#f9fafb";
    }
  };

  const validate = () => {
    const errs = {};

    if (!form.businessName.trim()) {
      errs.businessName = "Business name is required";
    } else if (form.businessName.trim().length < 2) {
      errs.businessName = "Business name must be at least 2 characters";
    }

    if (!form.legalEntityName.trim()) {
      errs.legalEntityName = "Legal entity name is required";
    } else if (form.legalEntityName.trim().length < 2) {
      errs.legalEntityName = "Legal entity name must be at least 2 characters";
    }

    if (!form.website.trim()) {
      errs.website = "Website is required";
    } else if (!urlPattern.test(form.website.trim())) {
      errs.website = "Enter a valid URL (e.g. https://www.example.com)";
    }

    if (!form.businessType) errs.businessType = "Please select a business type";
    if (!form.businessCategory)
      errs.businessCategory = "Please select a business category";
    if (!form.vintage) errs.vintage = "Please select vintage";
    if (!form.turnover) errs.turnover = "Please select annual turnover";
    if (!form.hasGST) errs.hasGST = "Please indicate GST registration status";

    if (!form.mobile.trim()) {
      errs.mobile = "Mobile number is required";
    } else if (!/^\d+$/.test(form.mobile.trim())) {
      errs.mobile = "Mobile number must contain only digits";
    } else if (form.mobile.trim().length !== 10) {
      errs.mobile = "Mobile number must be exactly 10 digits";
    } else if (!/^[6-9]/.test(form.mobile.trim())) {
      errs.mobile = "Mobile number must start with 6, 7, 8 or 9";
    }

    if (!form.email.trim()) {
      errs.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      errs.email = "Enter a valid email address";
    }

    return errs;
  };

  // ── ONLY handleSubmit is changed below ──────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setStatus("sending");

    const templateParams = {
      businessName: form.businessName,
      legalEntityName: form.legalEntityName,
      website: form.website,
      businessType: form.businessType,
      businessCategory: form.businessCategory,
      vintage: form.vintage,
      turnover: form.turnover,
      hasGST: form.hasGST,
      mobile: form.mobile,
      email: form.email,
    };

    const instituteOnboardingUrl = "/institute/info/onboarding-mail";
    try {
      // ── Step 1: Existing API (unchanged) ──────────────────
      await dispatch(userActions.instituteOnboarding(instituteOnboardingUrl, templateParams));

      // ── Step 2: Login to Supabase → get token + userId ────
      const loginResponse = await fetch(
        "https://pvafylzqrawbdhlmdecg.supabase.co/auth/v1/token?grant_type=password",
        {
          method: "POST",
          headers: {
            "apikey": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2YWZ5bHpxcmF3YmRobG1kZWNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5MDc4NzEsImV4cCI6MjA5MzQ4Mzg3MX0.fdXtENeLs3QY__NkCVbseCHNWXnYdAVIIcuJz8ZOhEk",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: "test@feemonk.com",
            password: "Test@123",
          }),
        }
      );
      const loginData   = await loginResponse.json();
      const accessToken = loginData.access_token;
      const userId      = loginData.user.id;

      // ── Step 3: Create lead in Supabase ───────────────────
      await fetch(
        "https://pvafylzqrawbdhlmdecg.supabase.co/rest/v1/leads",
        {
          method: "POST",
          headers: {
            "apikey":        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB2YWZ5bHpxcmF3YmRobG1kZWNnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc5MDc4NzEsImV4cCI6MjA5MzQ4Mzg3MX0.fdXtENeLs3QY__NkCVbseCHNWXnYdAVIIcuJz8ZOhEk",
            "Authorization": "Bearer " + accessToken,
            "Content-Type":  "application/json",
            "Prefer":        "return=representation",
          },
          body: JSON.stringify({
            // From website form
            name:           form.businessName,
            legal_name:     form.legalEntityName,
            website:        form.website,
            business_type:  form.businessType,
            institute_type: form.businessCategory,
            estd_year:      form.vintage,
            turnover:       form.turnover,
            gst_registered: form.hasGST === "Yes",
            contact_phone:  "+91" + form.mobile,
            contact_email:  form.email,
            // Meaningful values
            contact_name:   form.businessName,
            notes:          "Lead submitted via Feemonk website",
            // Hardcoded
            source:         "https://www.feemonk.com/",
            monthly_volume: "100",
            avg_ticket:     "50000",
            status:         "LEAD_CREATED",
            // From login response
            created_by:     userId,
          }),
        }
      );

      // ── Step 4: Show success (unchanged) ──────────────────
      setStatus("success");

    } catch (err) {
      setStatus("error");
    }
  };
  // ── END of handleSubmit changes ─────────────────────────────

  if (status === "success") {
    return (
      <div style={styles.wrapper}>
        <div
          style={{
            ...styles.card,
            maxWidth: "460px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={feemonk_logo}
            alt="Feemonk"
            style={{ width: "150px", marginBottom: "20px", display: "block" }}
          />
          <div style={styles.successIcon}>&#10003;</div>
          <h2
            style={{
              ...styles.title,
              fontSize: "1.2rem",
              marginBottom: "8px",
              textAlign: "center",
            }}
          >
            Thank You!
          </h2>
          <p
            style={{
              ...styles.subtitle,
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            Your interest has been submitted successfully. Our onboarding team
            will reach out to you shortly.
          </p>
          {/* <button
            style={{ ...styles.submitBtn, width: "100%" }}
            onClick={() => setStatus("idle")}
          >
            Submit Another
          </button> */}
        </div>
      </div>
    );
  }

  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <div
          style={{
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          <img
            src={feemonk_logo}
            alt="Feemonk"
            style={{
              width: "150px",
              marginBottom: "12px",
              display: "inline-block",
            }}
          />
          <div>
            <span
              style={{
                ...styles.headerTag,
                marginBottom: "10px",
              }}
            >
              Institute Onboarding
            </span>
          </div>
          <h1 style={{ ...styles.title, textAlign: "center" }}>
            Partner with Feemonk
          </h1>
          <p
            style={{
              ...styles.subtitle,
              textAlign: "center",
              maxWidth: "460px",
              margin: "0 auto",
            }}
          >
            Join leading education institutes that trust Feemonk. Fill out the
            form below and our team will get in touch.
          </p>
        </div>

        <form onSubmit={handleSubmit} noValidate style={{ textAlign: "left" }}>
          {/* Business Name */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Business Name <span style={styles.required}>*</span>
            </label>
            <input
              style={styles.input}
              type="text"
              name="businessName"
              placeholder="e.g. ABC Academy Pvt Ltd"
              value={form.businessName}
              onChange={handleChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
            />
            {errors.businessName && (
              <span style={styles.error}>{errors.businessName}</span>
            )}
          </div>

          {/* Legal Entity Name */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Legal Entity Name <span style={styles.required}>*</span>
            </label>
            <input
              style={styles.input}
              type="text"
              name="legalEntityName"
              placeholder="e.g. ABC Education Services Pvt Ltd"
              value={form.legalEntityName}
              onChange={handleChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
            />
            {errors.legalEntityName && (
              <span style={styles.error}>{errors.legalEntityName}</span>
            )}
          </div>

          {/* Website */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              Website <span style={styles.required}>*</span>
            </label>
            <input
              style={styles.input}
              type="url"
              name="website"
              placeholder="https://www.yourinstitute.com"
              value={form.website}
              onChange={handleChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
            />
            {errors.website && (
              <span style={styles.error}>{errors.website}</span>
            )}
          </div>

          {/* Business Type & Category */}
          <div style={styles.formRow}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Business Type <span style={styles.required}>*</span>
              </label>
              <select
                style={{
                  ...styles.select,
                  ...(!form.businessType
                    ? styles.selectPlaceholder
                    : styles.selectHasValue),
                }}
                name="businessType"
                value={form.businessType}
                onChange={handleChange}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onMouseOver={onSelectHover}
                onMouseOut={onSelectLeave}
              >
                <option value="" disabled hidden>
                  Select type
                </option>
                {BUSINESS_TYPES.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
              {errors.businessType && (
                <span style={styles.error}>{errors.businessType}</span>
              )}
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Business Category <span style={styles.required}>*</span>
              </label>
              <select
                style={{
                  ...styles.select,
                  ...(!form.businessCategory
                    ? styles.selectPlaceholder
                    : styles.selectHasValue),
                }}
                name="businessCategory"
                value={form.businessCategory}
                onChange={handleChange}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onMouseOver={onSelectHover}
                onMouseOut={onSelectLeave}
              >
                <option value="" disabled hidden>
                  Select category
                </option>
                {BUSINESS_CATEGORIES.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              {errors.businessCategory && (
                <span style={styles.error}>{errors.businessCategory}</span>
              )}
            </div>
          </div>

          {/* Vintage & Turnover */}
          <div style={styles.formRow}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Vintage <span style={styles.required}>*</span>
              </label>
              <select
                style={{
                  ...styles.select,
                  ...(!form.vintage
                    ? styles.selectPlaceholder
                    : styles.selectHasValue),
                }}
                name="vintage"
                value={form.vintage}
                onChange={handleChange}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onMouseOver={onSelectHover}
                onMouseOut={onSelectLeave}
              >
                <option value="" disabled hidden>
                  Select vintage
                </option>
                {VINTAGES.map((v) => (
                  <option key={v} value={v}>
                    {v}
                  </option>
                ))}
              </select>
              {errors.vintage && (
                <span style={styles.error}>{errors.vintage}</span>
              )}
            </div>

            <div style={styles.fieldGroup}>
              <label style={styles.label}>
                Annual Turnover <span style={styles.required}>*</span>
              </label>
              <select
                style={{
                  ...styles.select,
                  ...(!form.turnover
                    ? styles.selectPlaceholder
                    : styles.selectHasValue),
                }}
                name="turnover"
                value={form.turnover}
                onChange={handleChange}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
                onMouseOver={onSelectHover}
                onMouseOut={onSelectLeave}
              >
                <option value="" disabled hidden>
                  Select turnover
                </option>
                {TURNOVERS.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
              {errors.turnover && (
                <span style={styles.error}>{errors.turnover}</span>
              )}
            </div>
          </div>

          {/* GST Registration */}
          <div style={styles.fieldGroup}>
            <label style={styles.label}>
              GST Registered? <span style={styles.required}>*</span>
            </label>
            <div style={styles.toggleWrapper}>
              <div
                style={{
                  ...styles.toggleTrack,
                  background: form.hasGST === "Yes" ? "#F57C20" : "#e5e7eb",
                }}
                onClick={() => {
                  const newVal = form.hasGST === "Yes" ? "No" : "Yes";
                  setForm((prev) => ({ ...prev, hasGST: newVal }));
                  if (errors.hasGST) setErrors((prev) => ({ ...prev, hasGST: "" }));
                }}
              >
                <div
                  style={{
                    ...styles.toggleThumb,
                    left: form.hasGST === "Yes" ? "23px" : "3px",
                  }}
                />
              </div>
              <span
                style={{
                  ...styles.toggleLabel,
                  color: form.hasGST === "Yes" ? "#F57C20" : "#6b7280",
                }}
              >
                {form.hasGST === "Yes" ? "Yes" : "No"}
              </span>
            </div>
            {errors.hasGST && <span style={styles.error}>{errors.hasGST}</span>}
          </div>

          {/* Mobile Number & Email */}
          <div style={styles.formRow}>
            <div style={{ ...styles.fieldGroup, marginBottom: "20px" }}>
              <label style={styles.label}>
                Mobile Number <span style={styles.required}>*</span>
              </label>
              <div style={{ display: "flex", alignItems: "stretch" }}>
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "0 10px",
                    height: "40px",
                    background: "#FFF3E6",
                    border: "1.5px solid #e5e7eb",
                    borderRight: "none",
                    borderRadius: "8px 0 0 8px",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    color: "#F57C20",
                    whiteSpace: "nowrap",
                    boxSizing: "border-box",
                  }}
                >
                  +91
                </span>
                <input
                  style={{
                    ...styles.input,
                    borderRadius: "0 8px 8px 0",
                    flex: 1,
                  }}
                  type="tel"
                  name="mobile"
                  maxLength={10}
                  placeholder="9876543210"
                  value={form.mobile}
                  onChange={handleChange}
                  onFocus={onInputFocus}
                  onBlur={onInputBlur}
                  onMouseOver={onSelectHover}
                  onMouseOut={onSelectLeave}
                />
              </div>
              {errors.mobile && <span style={styles.error}>{errors.mobile}</span>}
            </div>

            <div style={{ ...styles.fieldGroup, marginBottom: "20px" }}>
              <label style={styles.label}>
                Email Address <span style={styles.required}>*</span>
              </label>
              <input
                style={styles.input}
                type="email"
                name="email"
                placeholder="contact@yourinstitute.com"
                value={form.email}
                onChange={handleChange}
                onFocus={onInputFocus}
                onBlur={onInputBlur}
              />
              {errors.email && <span style={styles.error}>{errors.email}</span>}
            </div>
          </div>

          {/* Submit */}
          <button
            type="submit"
            style={
              status === "sending" ? styles.submitBtnDisabled : styles.submitBtn
            }
            disabled={status === "sending"}
            onMouseOver={(e) => {
              if (status !== "sending") e.target.style.background = "#e06d15";
            }}
            onMouseOut={(e) => {
              if (status !== "sending") e.target.style.background = "#F57C20";
            }}
          >
            {status === "sending" ? "Submitting..." : "Submit Interest  \u2192"}
          </button>

          {status === "error" && (
            <p
              style={{
                color: "#ef4444",
                fontSize: "0.8rem",
                textAlign: "center",
                marginTop: "12px",
              }}
            >
              Something went wrong. Please try again later.
            </p>
          )}
        </form>
      </div>
    </div>
  );
}